import { CHART_COLORS, makeUnknownFromEmpty } from '../utils';

export const createBreakdownSeries = (data, isWaterfall) => {
	if (!data || !data.body || !data.body.length) {
		return [];
	}
	let processData = []
	if (isWaterfall) {
		processData = [...[...data.body].reverse()];
		if (data.notLoaded) {
			processData = [data.notLoaded, ...processData];
		}
		if (data.tailSpend) {
			processData = [data.tailSpend, ...processData]
		}
	} else {
		processData = data.body;
		if (data.notLoaded) {
			processData = [...processData, data.notLoaded];
		}
		if (data.tailSpend) {
			processData = [...processData, data.tailSpend];
		}
	}
	const emptyMap = processData.reduce((acc, { spendSplit }) => {
		spendSplit.forEach(split => {
			const existingItem = acc.find(serieItem => serieItem.name === split.name);
			if (!existingItem) {
				acc.push({
					name: split.name,
					data: [],
				})
			}
		})
		return acc;
	}, []);
	const resultData = emptyMap.map(emptySerie => {
		const data = [];
		const { name } = emptySerie;
		processData.forEach(({ spendSplit }) => {
			const itemInCategory = spendSplit.find(elem => elem.name === name);
			if (itemInCategory) {
				data.push(itemInCategory.spend);
			} else {
				data.push(0);
			}
		});
		return { name, data };
	});

	return resultData.filter(serie => serie.data.some(val => val !== 0)).map((serie, index) => {
		let data = serie.data.map((y, x) => ({
			y,
			name: makeUnknownFromEmpty(serie.name),
		}));

		if (isWaterfall) {
			const sum = data.reduce((acc, el) => acc + el.y, 0);
			const rootItem = {
				y: sum,
				name: serie.name,
			};
			const negativeRootItem = {
				y: -sum,
				name: '',
				visible: false,
			};
			data = [...data, negativeRootItem, rootItem];
		}

		const result = {
			...serie,
			color: CHART_COLORS[index],
			data,
		};
		return result;
	});
};

export const createNoneSeries = (data, isWaterfall) => {
	if (!data || !data.body || !data.body.length) {
		return [];
	}
	let processData = []
	if (isWaterfall) {
		processData = [...[...data.body].reverse()];
		if (data.notLoaded) {
			processData = [data.notLoaded, ...processData];
		}
		if (data.tailSpend) {
			processData = [data.tailSpend, ...processData]
		}
	} else {
		processData = data.body;
		if (data.notLoaded) {
			processData = [...processData, data.notLoaded];
		}
		if (data.tailSpend) {
			processData = [...processData, data.tailSpend];
		}
	}

	let series = [
		{
			name: 'parent',
			color: CHART_COLORS[0],
			data: processData.map(item => ({
				name: item.name,
				y: item.spend,
			})),
		},
	];
	if (isWaterfall) {
		const sum = series[0].data.reduce((acc, el) => acc + el.y, 0);
		const rootItem = {
			y: sum,
			name: 'root',
		};
		const negativeRootItem = {
			y: -sum,
			name: '',
			visible: false,
		};
		series[0].data = [...series[0].data, negativeRootItem, rootItem];
	}

	return series;
};
